import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Paper,
  Snackbar,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Backdrop,
  ThemeProvider,
  createMuiTheme,
  Divider,
  DialogActions, CardHeader, Dialog
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import Page from 'src/components/Page';
import CloseIcon from '@material-ui/icons/Close';
import 'react-confirm-alert/src/react-confirm-alert.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import axios from 'src/utils/axios';
import EditIcon from '@material-ui/icons/Edit';
import { getUser } from 'src/utils/Common';
import ExcelExport from 'src/components/ErpReportExcelExport';


const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  cardscontent: {
    minHeight: 530
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  nestedRight: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(7)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    maxHeight: 630
  }
}));
const localeMap = {
  tr: trLocale
};

const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

function PaymentReport() {

  const classes = useStyles();
  const { t } = useTranslation('overview');
  const dispatch = useDispatch();
  const [Status, setStatus] = useState('');
  const [statusList, setstatusList] = useState([]);
  const [serviceShopSelected, setServiceShopSelected] = useState('');
  const [subServiceShopList, setSubServiceShopList] = useState([]);
  const [initialRows, setinitialRows] = useState([]);
  const [serviceShopMaterialPopUp, setServiceShopMaterialPopUp] = useState(false);
  const [stokData, setStokData] = useState([]);
  const [workOrderErpDetailList, setWorkOrderDetailList] = useState([]);
  const [tempErpDocumentId, setTemErpDocumentId] = useState(0);
  const [erpDocumentPopup, setErpDocumentPopup] = useState(false)

  const [open, setOpen] = useState(false);
  const [erpDocumentList, setErpDocumentList] = useState([]);
  const [erpMMList, setErpMMList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [materialCode, setMaterialCode] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const locale = localStorage.getItem('i18nextLng');
  const SessionUser = getUser();
  const getStatus = async () => {
    setLoading(true);
    axios.get('/GetErpDocumentStatus')
      .then(response => {
        const res = response.data;
        dispatch(setstatusList(res));
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });

  }
  useEffect(() => {
    getStatus();
  }, [locale]);

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const getServiceShopForRegion = async (region) => {
    setLoading(true);
    axios.get('/GetServiceShopForRegion/' + region.RegionId)
      .then((response) => {
        setSubServiceShopList(response.data)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  async function changeStatus(Status) {
    setLoading(true);
    setStatus(Status)
    setLoading(false);
  }



  const getStokColor = s => {
    if (s.Quantity > 0) {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"
          onClick={() => {
            setUyari(s.SupplyDate || '');
            setOpen(true);
          }}
          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };

  const getData = async (temp) => {
    setLoading(true);
    axios.get(`/GetErpDocumentServiceShop/${temp[0]}/${temp[1]}/${temp[2]}/${temp[3]}`)
      .then((response) => {
        setinitialRows(response.data)
        setLoading(false);
        handleExcelData(response?.data);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  async function searchData() {
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const temp = [Status.Id, StartDate, EndDate, SessionUser?.ServiceShopId];
    getData(temp);
  }


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function handleExcelData(responseList) {

    if (!responseList) {
      return
    }

    var ExportData = responseList?.map(item => {
      return {
        Id: item.Id,
        StatusName: item.StatusName,
        DocumentType: item.DocumentType,
        DocumentNr: item.DocumentNr,
        EmployeeId: item.EmployeeId,
        EmployeeName: item.EmployeeName,
        InvoiceNr: item.InvoiceNr,
        LabourCost: item.LabourCost,
        MaterialCost: item.MaterialCost,
        ExtraCost: item.ExtraCost,
        TransportaionCost: item.TransportaionCost,
        HeadOfficeExtraCost: item.HeadOfficeExtraCost,
        TotalCost: item.TotalCost,
        ServiceName: item.ServiceName,
        ServiceShopId: item.ServiceShopId,
        TenantId: item.TenantId,
        InvoiceDate: item.InvoiceDate,
        CreateDate: item.CreateDate,
        SendDate: item.SendDate,
        UpdateDate: item.UpdateDate
      }
    });
    setErpDocumentList(ExportData)
    var erpDetailList = []
   

    for (var i = 0; i < responseList.length; i++) {
      var DetailData = JSON.parse(responseList[i]?.WorkOrderErpDetails);
      for (var j = 0; j < DetailData?.length; j++) {
        let temp = {
          Id: DetailData[j]?.Id,
          ErpDocumentId: responseList[i].Id,
          WorkOrderId: DetailData[j]?.WorkOrderId,
          RepairDate: DetailData[j]?.VerificationDate,
          DocumentType: DetailData[j]?.DocumentType,
          DocumentNr: DetailData[j]?.DocumentNr,
          StatusName: DetailData[j]?.StatusName,
          ErrorDescription: DetailData[j]?.ErrorDescription,
          EmployeeId: responseList[i].EmployeeId,
          EmployeeName: responseList[i].EmployeeName,
          ProjectCode: DetailData[j]?.ProjectCode,
          WarrantyType: DetailData[j]?.WarrantyType,
          InvoiceNr: responseList[i].InvoiceNr,
          LabourCost: DetailData[j]?.LabourCost,
          MaterialCost: DetailData[j]?.MaterialCost,
          ExtraCost: DetailData[j]?.ExtraCost,
          TransportaionCost: DetailData[j]?.TransportaionCost,
          TotalCost: DetailData[j]?.TotalCost,
          ServiceName: responseList[i].ServiceName,
          ServiceShopId: responseList[i].ServiceShopId,
          InvoiceDate: responseList[i].InvoiceDate,
          CreateDate: responseList[i].CreateDate,
          SendDate: responseList[i].SendDate,
          UpdateDate: responseList[i].UpdateDate,


        }
        erpDetailList.push(temp)
      }
    }



    setErpMMList(erpDetailList)
  }


  function openWorkOrderErpDetailPopup(erpDocumentId) {
    setLoading(true);
    axios.get(`/GetWorkOrderErpDetails/` + erpDocumentId)
      .then((response) => {
        if (response?.data?.length > 0) {
          setWorkOrderDetailList(response.data)
          setLoading(false);
          setTemErpDocumentId(erpDocumentId);
          setErpDocumentPopup(true);
        }
        else {
          setLoading(false)
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }


  return (
    <Page title="">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Container maxWidth="xl" spacing={1} className={classes.root}>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2} lg={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  autoSelect
                  disableClearable
                  value={Status || null}
                  options={statusList || []}
                  getOptionLabel={option => (option.Name ? option.Name : '')}
                  getOptionSelected={(option, value) =>
                    option.Id === value.Id
                  }
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('lblStatus')}
                      variant="outlined"
                    />
                  )}
                  onChange={(event, value) => {
                    changeStatus(value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('BaslangicTarihi')}
                      variant="outlined"
                      value={StartDateSearch}
                      onChange={e => handleChangeStartDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('BitisTarihi')}
                      variant="outlined"
                      value={EndDateSearch}
                      onChange={e => handleChangeEndDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => searchData()}
                  endIcon={<SearchIcon />}
                >
                  {t('lblSearch')}
                </Button>
              </Grid>

              <Grid item xs={12} sm={2} lg={2}>
                <ExcelExport JsonData={erpDocumentList} ButtonType={2} filename={"ErpTransaction"} />
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ExcelExport JsonData={erpMMList} ButtonType={5} filename={"ErpDetailList"} />
              </Grid>
            </Grid>
          </CardContent>
          <CardContent>
            <br />
            <TableContainer className={classes.container} component={Paper}>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                      <TableCell align="left">
                        {t('lblErpDocumentId')}
                      </TableCell>
                    <TableCell align="left">{t('lblEmployee')}</TableCell>
                    <TableCell align="left">
                      {t('lblInvoiceNumber')}
                    </TableCell>
                      <TableCell align="left">
                        {t('lblDocumentNumber')}
                      </TableCell>
                      <TableCell
                        style={{
                          whiteSpace: 'normal',
                          wordWrap: 'break-word'
                        }}
                        align="left"
                      >
                        {t('lblErrorDescription')}
                      </TableCell>
                    <TableCell align="left">
                      {t('lblMaterialCost')}
                    </TableCell>
                    <TableCell align="left">{t('lblLabourCost')}</TableCell>
                    <TableCell align="left">
                      {t('lblTransportationCost')}
                    </TableCell>
                    <TableCell align="left">{t('lblExtraCost')}</TableCell>
                    <TableCell align="left">{t('lblHeadOfficeExtraCost')}</TableCell>
                    <TableCell align="left">{t('lblTotalCost')}</TableCell>
                    <TableCell align="left">{t('lblCreateDate')}</TableCell>
                    <TableCell align="left">{t('lblSendDate')}</TableCell>
                    <TableCell align="left">
                      {t('lblInvoiceDate')}
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {erpDocumentList.map(row => (
                    <TableRow key={row.Id}>
                      <TableCell align="left">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          fullWidth
                          onClick={() => openWorkOrderErpDetailPopup(row.Id)}
                          endIcon={<EditIcon />}
                        >
                          {row.Id}
                        </Button>
                      </TableCell>
                      <TableCell align="left">{row.EmployeeName}</TableCell>
                      <TableCell align="left">{row.InvoiceNr}</TableCell>
                      <TableCell align="left">{row.DocumentNr}</TableCell>
                      <TableCell align="left">
                        {row.ErrorDescription}
                      </TableCell>
                      <TableCell align="left">{row.MaterialCost}</TableCell>
                      <TableCell align="left">{row.LabourCost}</TableCell>
                      <TableCell align="left">
                        {row.TransportaionCost}
                      </TableCell>
                      <TableCell align="left">{row.ExtraCost}</TableCell>
                      <TableCell align="left">{row.HeadOfficeExtraCost}</TableCell>
                      <TableCell align="left">{row.TotalCost}</TableCell>
                      <TableCell align="left">
                        {moment(row.CreateDate).format('DD.MM.YYYY')}
                      </TableCell>
                      <TableCell align="left">
                        {row.SendDate
                          ? moment(row.SendDate).format('DD.MM.YYYY')
                          : ''}
                      </TableCell>
                      <TableCell align="left">
                        {row.InvoiceDate
                          ? moment(row.InvoiceDate).format('DD.MM.YYYY')
                          : ''}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>

      <Dialog
        open={erpDocumentPopup}
        fullWidth
        maxWidth='lg'
        onClose={() => setErpDocumentPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card style={{ marginTop: '25px', marginBottom: '15px' }}>
            <CardHeader title={`${t('lblErpDocumentId')}: ${tempErpDocumentId}`} />
            <Divider />
            <CardContent className={classes.cardscontent} >
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>

                  <TableContainer className={classes.container} component={Paper}>
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {t('lblInvoiceNumber')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblWorkOrderId')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblErpDocumentId')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDocumentDescription')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDocumentNr')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblErrorDescription')}
                          </TableCell>

                          <TableCell />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {workOrderErpDetailList.map(row => (
                          <TableRow key={row.Id}>
                            <TableCell align="left">{row.InvoiceNr}</TableCell>
                            <TableCell align="left">{row.WorkOrderId}</TableCell>
                            <TableCell align="left">{row.ErpDocumentId}</TableCell>
                            <TableCell align="left">{row.DocumentDescription}</TableCell>
                            <TableCell align="left">{row.DocumentNr}</TableCell>
                            <TableCell align="left">{row.ErrorDescription}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => setErpDocumentPopup(false)}
            aria-label="close"
            component="span"
            variant="contained"
            endIcon={<CloseIcon />}
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

    </Page>
  );
}
export default PaymentReport;
